// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2OwnQ","containerItemsCenter":"Skeleton_containerItemsCenter__1TX6I"};